import { createSelector } from 'reselect';
import {
    getInternalWebsiteBaseUrl,
    getPublicWebsiteBaseUrl
} from 'web-common/scripts/utils/whitelabelUtils';

export const eventSelector = state => state.eventReducer.event;

export const getPublicWebsiteBaseUrlSelector = createSelector(
    eventSelector,
    event => getPublicWebsiteBaseUrl(event)
);

export const getInternalWebsiteBaseUrlSelector = createSelector(
    eventSelector,
    event => getInternalWebsiteBaseUrl(event)
);

export const getCommunityUrl = createSelector(
    eventSelector,
    (event) => {
        const { websiteType, communityUrl, independentUrl } = event;
        if (websiteType === 'independent') {
            return communityUrl || independentUrl;
        }
        return communityUrl || `${getInternalWebsiteBaseUrl(event, 'community')}`;
    }
);

export const getAgendaUrl = createSelector(
    eventSelector,
    (event) => {
        const { websiteType, agendaUrl, independentUrl } = event;
        if (websiteType === 'independent') {
            return agendaUrl || independentUrl;
        }
        return agendaUrl || `${getInternalWebsiteBaseUrl(event, 'agenda')}`;
    }
);

export const getInternalAgendaUrl = createSelector(
    eventSelector,
    (event) => `${getInternalWebsiteBaseUrl(event, '/agenda')}`
);

export const getRegistrationsUrl = createSelector(
    eventSelector,
    (event) => {
        const { websiteType, registrationsUrl, independentUrl } = event;
        if (websiteType === 'independent') {
            return registrationsUrl || independentUrl;
        }
        return registrationsUrl || `${getInternalWebsiteBaseUrl(event)}`;
    }
);

export const eventGroupIdSelector = createSelector(
    eventSelector,
    (event) => event.groupId
);

export const enableTicketIdLoginSelector = createSelector(
    eventSelector,
    (event) => event.enableTicketIdLogin
);

export const eventWelcomeMessagesSelector = createSelector(
    eventSelector,
    (event) => event['welcome-message'] || ''
);

export const websiteTypeSelector = createSelector(
    eventSelector,
    (event) => event.websiteType
);

export const whitelabelPathSelector = createSelector(
    eventSelector,
    (event) => event.whitelabelPath
);

export const whitelabelUrlSelector = createSelector(
    eventSelector,
    (event) => event.whitelabelUrl
);

export const whitelabelWidgetEnabledSelector = createSelector(
    eventSelector,
    (event) => event.whitelabelWidgetEnabled
);

export const onlyEventDomainSelector = createSelector(
    eventSelector,
    (event) => event.onlyEventDomain
);

export const eventUrlsSelector = createSelector(
    eventSelector,
    getPublicWebsiteBaseUrlSelector,
    getCommunityUrl,
    getAgendaUrl,
    getRegistrationsUrl,
    getInternalWebsiteBaseUrlSelector,
    (event, publicWebsiteBaseUrl, communityUrl, agendaUrl, registrationsUrl) => ({
        publicWebsiteBaseUrl,
        communityUrl,
        agendaUrl,
        registrationsUrl
    })
);

export const isEventIndependentSelector = createSelector(eventSelector, event => event.websiteType === 'independent');

export const eventTimezoneSelector = createSelector(eventSelector, event => event?.['time-zone-id']);
export const eventStartDateSelector= createSelector(eventSelector, event => event?.['start-date']);
export const eventEndDateSelector = createSelector(eventSelector, event => event?.['end-date']);

export const eventIdSelector = createSelector(eventSelector, event => event?.id);

export const eventUniqueNameSelector = createSelector(
    eventSelector,
    event => event?.['unique-name']
);

export const accountIdSelector = createSelector(
    eventSelector,
    event => event?.['account-id']
);
